import { createContext, useContext } from 'react'
import type { VipStatus } from '../view-types'
import type { PaymentOrder, PaymentProvider } from '../api'
export type VipTier = 'vip' | 'svip'
export const VipContext = createContext({
  vipStatus: 'unknown' as VipStatus, svipStatus: 'unknown' as VipStatus, error: '',
  soundEnabled: true, reduceMotion: false,
  initialTier: null as VipTier | null,
  returnOrderId: null as string | null,
  selectTier: (_tier: VipTier | null) => {},
  clearReturnOrder: () => {},
  refreshEntitlements: async () => {},
  beginPayment: async (_tier: VipTier, _provider: PaymentProvider, _mutationId: string, _signal?: AbortSignal): Promise<PaymentOrder> => { throw new Error('支付服务尚未初始化') },
  getPayment: async (_orderId: string, _signal?: AbortSignal): Promise<PaymentOrder> => { throw new Error('支付服务尚未初始化') },
  confirmPayment: async (_orderId: string, _signal?: AbortSignal): Promise<PaymentOrder> => { throw new Error('支付服务尚未初始化') }
})
export const useVip = () => useContext(VipContext)
